import Axios from "@/plugins/axios";

class TestApi {
    getTestQuestionDomainById(id) {
        return Axios.get('api/test_question_domains/' + id);
    }

    getQuestion(idQuestion) {
        return Axios.get('api/test_questions/' + idQuestion)
    }

    getUserTestContent(userId) {
        return Axios.get('api/user/' + userId + '/mes-tests');
    }

    getUserTestQuestions(userId, idDomain) {
        return Axios.get('api/user/' + userId + '/' + idDomain + '/questions');
    }

    debutQuestionnaire(userId, domain) {
        return Axios.post('api/user/questionnaire/create', {
            userId: userId,
            domainId: domain
        });
    }

    resetQuestionnaire(id) {
        return Axios.put('api/user_test_result_by_domains/' + id, {
            deletedAt: new Date().toJSON()
        });
    }

    terminatedTest(id) {
        return Axios.post('api/user/questionnaire/finish', {
            terminatedByUserAt: new Date().toJSON(),
            id: id
        });
    }

    saveListen(id, listen) {
        return Axios.put('api/user_test_result_by_domains/' + id, {
            listenTime: listen
        });
    }

    saveAnswerQuestion(id, numQuestion, answer) {
        return Axios.post('api/user/questionnaire/question/save', {
            id: id,
            numQuestion: numQuestion,
            answer: answer
        }).then(response => {
            if (response.data && response.data.error) {
                return {error: response.data.error};
            }
            return response;
        });
    }

    sendQuestionnaire(userId) {
        return Axios.post('api/user/questionnaire/send', {
            id: userId
        });
    }

    saveQuestionnaireToEva(userId) {
        return Axios.post('api/user/questionnaire/saveToEva', {
            id: userId
        });
    }

    getResponseQuestion(idDomain, numQuestion) {
        return Axios.get('api/user/questionnaire/question/get/' + idDomain + '/' + numQuestion);
    }
}

export default new TestApi();
